module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-900-[78]565.67a54fa.woff2";